// Create_testimonial.js
import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Nav, Form, Button, Image, Modal } from "react-bootstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import authToken from "./../token/Token";
import { testimonialsApi } from "./../API/api";

const Create_testimonial = () => {
  const [clientName, setclientName] = useState("");
  const [clientRole, setclientRole] = useState("");
  const [message, setmessage] = useState("");
  const [profileImage, setprofileImage] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();

  const handleprofileImageUpload = (e) => {
    const files = e.target.files;
    setprofileImage(files);

    const previews = [];
    for (let i = 0; i < files.length; i++) {
      const reader = new FileReader();
      reader.onload = (event) => {
        previews.push(event.target.result);
        if (previews.length === files.length) {
          setImagePreviews(previews);
        }
      };
      reader.readAsDataURL(files[i]);
    }
  };

  const handleProjectUrlChange = (event, editor) => {
    const data = editor.getData();
    setmessage(data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("client_name", clientName);
    formData.append("client_role", clientRole);
    formData.append("message", message);

    if (profileImage.length > 0) {
      formData.append("profile_image", profileImage[0]);
    }

    try {
      const response = await fetch(testimonialsApi, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("Upload successful:", data);

      setShowModal(true);
    } catch (error) {
      console.error("Error uploading data:", error.message);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    history.push("/components/testimonial");
  };

  return (
    <section>
      <div className="container wrap-section-1">
        <div className="row mx-3">
          <div className="col">
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="formclientName" className="mb-3">
                <Form.Label>client_name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter client_name"
                  value={clientName}
                  onChange={(e) => setclientName(e.target.value)}
                  required
                />
              </Form.Group>
              <Form.Group controlId="formclientRole" className="mb-3">
                <Form.Label>client_role</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter client_role"
                  value={clientRole}
                  onChange={(e) => setclientRole(e.target.value)}
                  required
                />
              </Form.Group>
              <Form.Group controlId="formmessage" className="mb-3">
                <Form.Label>message</Form.Label>
                <CKEditor
                  editor={ClassicEditor}
                  data={message}
                  onChange={handleProjectUrlChange}
                  required
                />
              </Form.Group>
              <Form.Group controlId="formprofileImage" className="mb-3">
                <Form.Label>profile_image</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handleprofileImageUpload}
                  required
                />
                {/* Display image previews */}
                {imagePreviews.map((preview, index) => (
                  <Image
                    key={index}
                    src={preview}
                    alt={`Preview ${index}`}
                    fluid
                    rounded
                    className="mt-2"
                  />
                ))}
              </Form.Group>
              <Button variant="warning" type="submit">
                Submit
              </Button>
              <Button className="ms-2" variant="danger">
                <Nav.Link as={Link} to="/components/testimonial">
                  Close
                </Nav.Link>
              </Button>
            </Form>

            {/* Modal for success notification */}
            <Modal show={showModal} onHide={handleCloseModal}>
              <Modal.Header closeButton>
                <Modal.Title>Upload Berhasil</Modal.Title>
              </Modal.Header>
              <Modal.Body>Data project berhasil ditambahkan!</Modal.Body>
              <Modal.Footer>
                <Button variant="warning" onClick={handleCloseModal}>
                  OK
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Create_testimonial;
